import { render, staticRenderFns } from "./MainPropDataTablePanel.vue?vue&type=template&id=4b2f2242&scoped=true"
import script from "./MainPropDataTablePanel.vue?vue&type=script&lang=js"
export * from "./MainPropDataTablePanel.vue?vue&type=script&lang=js"
import style0 from "./MainPropDataTablePanel.vue?vue&type=style&index=0&id=4b2f2242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2f2242",
  null
  
)

export default component.exports